import React from 'react'
import { authouterpageProps } from './authouterpage-interface'
import { Row, Col } from 'antd'
import { useNavigate } from 'react-router-dom'

const Authouterpage = ({ children, isPasswordRelated }: authouterpageProps) => {
	const navigate  = useNavigate()
	
	return (
		<div className='h-screen custom-primary-bg px-[7.1rem] pt-[4.4rem] overflow-x-hidden overflow-y relative'>

			{
				!isPasswordRelated ?
					<Row align="middle" gutter={64}>
						<Col lg={12} md={24} xs={12}>
							<div className='flex flex-col items-center justify-center'>
								<div className='mb-[4.7rem]'>
									<img src="/img/vectors/outerpageboy.svg" alt="outerpageboy" />
								</div>
								<p className='font-bold text-appcolorwhite text-[28px] leadin
            g-[37px]'>
									Access easy-to understand tutorials for
									<br className='hidden lg:block' />
									your learning process
								</p>
							</div>
						</Col>

						<Col lg={12} md={24} xs={12}>
							<div className='z-[1000] relative'>
								{children}
							</div>
						</Col>
					</Row>
					:
					null
			}

			{
				isPasswordRelated ?
				<div>
					<div className='flex items-center cursor-pointer w-fit'
					onClick={() => {
						navigate(-1)
					}}
					>
						<img src="/img/vectors/dashicon.svg" alt="dash" />
						<p className='text-appcolorwhite text-[18px] leading-[22px] ml-2'>Go Back</p>
					</div>

					<div>
						{children}
					</div>
				</div>
				: null
			}



			<img
				className="fixed h-[21rem] bottom-[10rem] right-0"
				src="/img/vectors/eclipsetop.svg"
				alt="background" />

			<img
				className="fixed right-0 bottom-0 w-[24rem] h-[25.7rem]"
				src="/img/vectors/eclipsebottom.svg"
				alt="background" />
		</div>
	)
}

Authouterpage.defaultProps = {
	isPasswordRelated: false,
}

export default Authouterpage